import { Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDashboardData } from "../adminDashboard/dashboardSlice";
import Repo from "../../Repository/Repo";
import moment from "moment";

function AmountSection({ mode, state, items,employeesReportTotalSales="" }) {
  console.log('sssssss', items)
  console.log('s', state)
  console.log('employess', employeesReportTotalSales)


  const numberItems = Number(items)
  const totalSalesAmount = items?.reduce((acc,curr)=> {
    acc = acc + Number(curr.total || 0)
    return acc
  },0)
  const totalQuantity = items?.flatMap(item => 
    item?.items?.map(subItem => Number(subItem.quantity) || 0)
  ) ?? [];
  console.log('u', totalQuantity)

  const totalQuantitySum =    totalQuantity.reduce((acc ,curr ) => acc + Number(curr) ,0)
console.log('uu', totalQuantitySum)
  // item?.items?.reduce((acc ,curr ) => acc + curr.quantity ,0)
//  console.log('totallll', items?.items)

console.log('totalQuantity', totalQuantity)
  const dispatch = useDispatch();
  const { totalStockValue , totalStockSaleValue} = useSelector((state) => state.inventory);
  const [loading, setLoading] = useState(false);
console.log('stateAmount', state);
  useEffect(() => {
    if (mode == "credit") {
      getCredit();
    } 
    // else if(mode == "stock"){
    //    dispatch(getDashboardData());
    // }
  }, []);

  const getCredit = async () => {
    try {
      let { data } = await Repo.ledger({
        request: {
          method: "getDayCreditByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
            startDate: moment().format("DD-MM-YYYY"),
            endDate: moment().format("DD-MM-YYYY"),
          },
        },
      });
      console.log("data:", data);
    } catch (err) {
      console.log("err:", err);
    }
  };

  return (
    <div>
      {mode == "credit" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Amount:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.credit}</Typography>
          </Stack>
        </Stack>
      )}
      {(mode == "combinedSales" ) && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Amount:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.credit}</Typography>
          </Stack>
          <Stack width="300px" direction="row" spacing={4}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Profit:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.profit}</Typography>
          </Stack>
        </Stack>
      )}

{( mode == "sales") && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Amount:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{totalSalesAmount?.toFixed(3)}</Typography>
          </Stack>
          {/* <Stack width="300px" direction="row" spacing={4}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Profit:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.profit}</Typography>
          </Stack>
          <Stack width="300px" direction="row" spacing={4}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Loss:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.loss}</Typography>
          </Stack> */}
        </Stack>
      )}

      {mode == "salesReturn" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Amount:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.credit}</Typography>
          </Stack>
        </Stack>
      )}
      {mode == "purchase" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Purchase:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>
              {state.totalPurchase}
            </Typography>
          </Stack>
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Paid:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.totalPaid}</Typography>
          </Stack>
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Remaining:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>
              {state.totalRemaining}
            </Typography>
          </Stack>
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Quantity:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>
              {totalQuantitySum}
            </Typography>
          </Stack>
        </Stack>
      )}
      {mode == "purchaseReturn" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Purchase:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>
              {state.totalPurchase}
            </Typography>
          </Stack>
        </Stack>
      )}
      {mode == "expense" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Amount:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.credit}</Typography>
          </Stack>
        </Stack>
      )}
      {mode == "stock" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Stock Value:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{totalStockValue}</Typography>
          </Stack>
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Sale Stock Value:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{ totalStockSaleValue}</Typography>
          </Stack>
        </Stack>
      )}
      {mode == "supplierPurchase" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Amount:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>
              {state.totalPurchase}
            </Typography>
          </Stack>
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Quantity:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>
              {totalQuantitySum}
            </Typography>
          </Stack>
        </Stack>
      )}
      {mode == "gatePass" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Profit:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.profit}</Typography>
          </Stack>
        </Stack>
      )}
      {mode == "customerSale" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Amount:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.credit}</Typography>
          </Stack>
          {/* <Stack width="300px" direction="row" spacing={2}>
            <Typography>Debit:</Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.debit}</Typography>
          </Stack> */}
        </Stack>
      )}
        {mode == "banksReport" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Credit:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.credit || 0}</Typography>
          </Stack>
          <Stack width="300px" direction="row" spacing={2}>
            <Typography>Total Debit:</Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.debit || 0}</Typography>
          </Stack>
          <Stack width="300px" direction="row" spacing={2}>
            <Typography>Balance:</Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state.balance || 0}</Typography>
          </Stack>
        </Stack>
      )}
      {mode == "employeeReport" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Amount:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{employeesReportTotalSales || 0}</Typography>
          </Stack>
        </Stack>
      )}

{mode == "paymentReport" && (
        <Stack margin="20px" alignItems="flex-end" justifyContent="flex-end">
          <Stack width="300px" direction="row" spacing={2}>
            <Typography sx={{ ml: { md: "0px", xs: "20px" } }}>
              Total Amount:
            </Typography>
            <Typography sx={{ color: "#4eaf51" }}>{state?.totalPayment || 0}</Typography>
          </Stack>
        </Stack>
      )}
    </div>
  );
}

export default AmountSection;
